import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "process-journal",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "project-group" */ "./components"),
        import(/* webpackChunkName: "project-group" */ "./modules/Module"),
        import(
          /* webpackChunkName: "project-group" */ "MultiLevelNodeEditor/modules/MultiLevelNodeEditorModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        const multiLevelNodeEditorReducer = importedModule2.default;
        const reducer = module.default;
        injectReducer(store, {
          key: module.NAME,
          reducer,
        });
        injectReducer(store, {
          key: "multiLevelNodeEditor",
          reducer: multiLevelNodeEditorReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
